import api from './api';

export const fileService = {
  // List files (optionally filter by folder)
  listFiles: async (folderId = null) => {
    const params = folderId ? { folder_id: folderId } : {};
    const response = await api.get('/files/', { params });
    return response.data;
  },

  // Upload file
  uploadFile: async (file, folderId = null) => {
    const formData = new FormData();
    formData.append('file', file);
    if (folderId) {
      formData.append('folder_id', folderId);
    }

    const response = await api.post('/files/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Download file
  downloadFile: async (fileId, filename) => {
    const response = await api.get(`/files/${fileId}/download`, {
      responseType: 'blob',
    });
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  // Download file as blob for preview (no download prompt)
  downloadFileBlob: async (fileId) => {
    const response = await api.get(`/files/${fileId}/download`, {
      responseType: 'blob',
    });
    return response.data;
  },

  // Delete file
  deleteFile: async (fileId) => {
    await api.delete(`/files/${fileId}`);
  },

  // Search files
  searchFiles: async (query, folderId = null) => {
    const params = { q: query };
    if (folderId) {
      params.folder_id = folderId;
    }
    const response = await api.get('/files/search', { params });
    return response.data;
  },

  // Get shared files
  getSharedWithMe: async () => {
    const response = await api.get('/files/shared/with-me');
    return response.data;
  },

  // Share file
  shareFile: async (fileId, shareData) => {
    const response = await api.post('/files/share', {
      file_id: fileId,
      ...shareData
    });
    return response.data;
  },

  // Get file versions
  getFileVersions: async (fileId) => {
    const response = await api.get(`/files/${fileId}/versions`);
    return response.data;
  },

  // Download specific version
  downloadFileVersion: async (fileId, versionId, filename) => {
    const response = await api.get(`/files/${fileId}/versions/${versionId}/download`, {
      responseType: 'blob',
    });
    
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  // Restore file version
  restoreFileVersion: async (fileId, versionId) => {
    const response = await api.post(`/files/${fileId}/versions/${versionId}/restore`);
    return response.data;
  },

  // Get files shared with me
  getSharedFiles: async () => {
    const response = await api.get('/files/shared/with-me');
    return response.data;
  },

  // Get shares for a specific file
  getFileShares: async (fileId) => {
    const response = await api.get(`/files/${fileId}/shares`);
    return response.data;
  },

  // Remove a share
  removeShare: async (shareId) => {
    const response = await api.delete(`/files/share/${shareId}`);
    return response.data;
  },
};
